<template>
  <l-map
    :style="desktop ? 'height: 800px; border-radius: 10px' : 'height: 500px; border-radius: 10px'"
    :zoom="zoomLarge"
    :center="centerMap"
    ref="mappaItinerario"
  >
    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
    <l-marker
      v-for="(marker, index) in markers"
      :lat-lng="marker.marker['_latlng']"
      :key="'marker' + index"
    >
      <l-icon
        :icon-anchor="dynamicAnchor"
        v-if="marker.poiSelected"
        :icon-url="require('../../../icons/inItineraryWatchedPOI.svg')"
      ></l-icon>
      <l-icon
        :icon-anchor="dynamicAnchor"
        v-else-if="index === 0 && !marker.poiSelected"
        :icon-url="require('../../../icons/selected/startHere.svg')"
      ></l-icon>
      <l-icon
        :icon-anchor="dynamicAnchor"
        v-else-if="marker.POIdescription.includes('pranzo')"
        :icon-url="getCorrectMarkerIcon()"
      ></l-icon>
      <l-icon
        :icon-anchor="dynamicAnchor"
        v-else-if="!marker.poiSelected"
        :icon-url="require('../../../icons/inItineraryPOI.svg')"
      ></l-icon>
      <l-popup :options="anchorOptions" style="max-width: 250px">
        <div class="px-3">
          <div class="row">
            <h5>{{ marker.POItitle }}</h5>
          </div>
          <div
            class="row text-justify fadeeffect"
            style="max-height: 100px; overflow: scroll"
          >
            {{ marker.POIdescription }}
          </div>
          <div class="row mt-3">
            <div class="col-12 text-center">
              <img
                v-if="marker.image !== undefined"
                v-img="{ group: getGroupNameMarker(marker) }"
                class="margin-auto"
                style="border-radius: 5px"
                :src="marker.image"
                :alt="marker.POItitle"
              />
              <img
                v-else
                v-img="{ group: getGroupNameMarker(marker) }"
                class="postcard__img"
                src="@/assets/images/bg3.jpg"
                style="border-radius: 5px"
                :alt="marker.POItitle"
              />
            </div>
          </div>
        </div>
      </l-popup>
    </l-marker>

    <!--fontanelle-->
    <div v-if="showDrinkingWater">
      <l-marker
        v-for="(waterPoint, index) in drinkingWaterPoints"
        :lat-lng="waterPoint.marker['_latlng']"
        :key="'waterPoint' + index"
      >
        <l-icon
          :icon-anchor="dynamicAnchor"
          :icon-url="require('../../../icons/drinking_water.svg')"
        ></l-icon>

        <l-popup :options="anchorOptions" style="max-width: 250px">
          <div class="px-3">
            <div class="row">
              <h5>{{ waterPoint.POItitle }}</h5>
            </div>
            <div
              class="row text-justify fadeeffect"
              style="max-height: 100px; overflow: scroll"
            >
              {{ waterPoint.POIdescription }}
            </div>
          </div>
        </l-popup>
      </l-marker>
    </div>
  </l-map>
</template>
  
  <script>
const Common = require("@/Common.vue").default;

import $ from "jquery";

import { isMobile } from "mobile-device-detect";
// import { config } from "../../utils/config";
import { LMap, LMarker, LPopup, LIcon, LTileLayer } from "vue2-leaflet";

export default {
  name: "mappa-sintesi-itinerario",
  props: ["markers", "drinkingWaterPoints", "showDrinkingWater", "desktop", "selectedLunchPoint"],

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
  },

  data() {
    return {
      selectedTab: "Panoramica",
      windowWidth: 0,
      isLoadingImages: true,
      isLoadingVideos: true,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      isMobile: false,
      isGeodidalab: false,

      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 16,
      zoomLarge: 14,
      center: [45.47724690648075, 7.888264286334166],
      anchorOptions: { offset: L.point(-6.5, -37) },
    };
  },
  created() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    // this.isGeodidalab = config.isGeodidalab;
  },

  methods: {
    getGroupNameMarker(marker) {
      return marker.POItitle.replaceAll('"', "");
    },
    getCorrectMarkerIcon() {
      if (this.selectedLunchPoint.type === "restaurant") {
        return require("../../../icons/restaurant.svg");
      } else if (
        this.selectedLunchPoint.type === "bar" ||
        this.selectedLunchPoint.type === "cafe"
      ) {
        return require("../../../icons/bar.svg");
      } else if (this.selectedLunchPoint.type === "picnic_site") {
        return require("../../../icons/picnicSite.svg");
      } else if (this.selectedLunchPoint.type === "pub") {
        return require("../../../icons/pub.svg");
      } else if (this.selectedLunchPoint.type === "fast_food") {
        return require("../../../icons/fast_food.svg");
      }
    },
  },
  computed: {
    dynamicAnchor() {
      return [20, 64 * 0.65];
    },
    centerMap() {
      var sumLat = 0;
      var sumLng = 0;

      Array.prototype.forEach.call(this.markers, (marker) => {
        sumLat += marker.marker["_latlng"].lat;
        sumLng += marker.marker["_latlng"].lng;
      });

      var middleLat = sumLat / this.markers.length;
      var middleLng = sumLng / this.markers.length;

      if (isNaN(middleLat) || isNaN(middleLng)) {
        return [45.47724690648075, 7.888264286334166];
      } else {
        return [middleLat, middleLng];
      }
    },
  },

  mounted() {
    this.isMobile = isMobile;

    var self = this;
  },
};
</script>
  
  <style lang="scss">
</style>